import Group from "./group";
import Skeleton from "./skeleton";

Skeleton.Group = Group;
export default Skeleton;
